/**
 * Service worker registration — Sprint 6, SDD §7.6
 *
 * Registers the service worker in production. In development, the service
 * worker is skipped to avoid caching issues with Vite's HMR.
 */

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  // Don't register during development (Vite dev server)
  if (import.meta.env.DEV) return;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
            // New service worker activated — the app will use the new cache on next load
            console.log('[SW] New version available. Refresh for updates.');
          }
        });
      });

      console.log('[SW] Service worker registered successfully.');
    } catch (error) {
      console.error('[SW] Service worker registration failed:', error);
    }
  });
}
